





















    import { Component, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import CallDirectionFilter from './filter-container/CallDirectionFilter.vue';
    import AnsweredFilter from './filter-container/AnsweredFilter.vue';
    import ExtensionsFilter from './filter-container/ExtensionsFilter.vue';
    import TimeZoneFilter from './filter-container/TimezoneFilter.vue';
    import DateRangeFilter from './filter-container/DateRangeFilter.vue';  
    import { StoreState ,Timezone,CDR} from '../../store';  
    import momentTZ from 'moment-timezone';
    import XLSX from 'xlsx'; 
    import {saveAs} from 'file-saver';   
    import * as moment from 'moment';  


    @Component({
        components: {
            CallDirectionFilter,
            AnsweredFilter,
            ExtensionsFilter,
            TimeZoneFilter,
            DateRangeFilter
        },
        computed: {
            ...mapState({
                'cdrs'      : (state: StoreState) => state.reports.callReportsHistory,
                'startDate' : (state: StoreState) => state.reports.filters.startDate,
                'endDate'   : (state: StoreState) => state.reports.filters.endDate,
                'timezone'  : (state: StoreState) => state.reports.filters.timezone,
                'callReports': (state: StoreState) => state.reports.callReports,
                'extensionsList': (state: StoreState) => state.reports.filters.extensionsList,//
            })
        },
        mounted () {
            this.$store.commit('INBOUND_CALL_CHANGE', { newVal:true });
            this.$store.commit('OUTBOUND_CALL_CHANGE',{ newVal:true });
            this.$store.commit('ANSWERED_YES_CHANGE', { newVal:true });
            this.$store.commit('ANSWERED_NO_CHANGE',  { newVal:true });
             this.$store.commit("CALLREPORT_SLIDER", true);  
           // this.getCallReports();
            this.$store.dispatch('getExtensions').then((r) => {
            this.getCallReports();
             }).catch((r) => {
                })  
        },
        beforeDestroy() {
           this.$store.commit('SET_CURRENT_FILTERS_RUN', {filtersRun: false });
        }
      
    })

    export default class FilterContainer extends Vue{
        timezone!: Timezone;
        cdrs!: CDR[];
        startDate!: Date | null;
        endDate!: Date | null;
        loading = false;
        dateError = false;
        summary_loading=false;
        repsummary=false;
 

       


        convrdate(DueDate){
            //  var DueDate = parseDate(DueDate_Data_input.value.split(" ")[0].replace("-", "/").replace("-", "/"));
                var dd = ("0" + DueDate.getDate()).slice(-2);
                var mm = ("0" + (DueDate.getMonth() + 1)).slice(-2);
                var y = DueDate.getFullYear();
            var someFormattedDate = y + '-' + mm + '-' + dd;
            return   someFormattedDate;
        }



        getCallReports() {
            //alert('callrep')
            this.dateError = false;
            if (!this.startDate || !this.endDate) {
                this.dateError = true;
            }
            if (!this.loading && !this.dateError) {
                this.loading = true; 
               this.$store.commit("CALLREPORT_SLIDER", true); 
               this.$store.commit("SearchText_CLEAR",true);
                this.$store.commit('SearchText_update', '');
                this.$store.commit('UPDATE_CALL_REPORTS', { cdrs:[], total:0, monthindex:0,clear:true });
                  this.$store.commit('SET_BOOKMARK', { bookmark:'' });
                  var payload={
                    reporsort_Statu:false,
                    sortBy   : '',
                    ststus   :  false
                  }
               this.$store.commit('SET_CALLREPORT_SORT', payload);  
                this.$store.dispatch('getCallReports', {para:{ shouldContinue: false,Page:1}})
                .then((r) => {
                     this.loading = false;
                     console.log((this as any).callReports.length)
                    this.$emit('CloseDrawer');
                    this.$store.commit("CALLREPORT_SLIDER", false);
                    this.$store.commit('LOAD_MORE_BAR_VISIBLE', { isVisible: false,});
                    this.loading = false;
                }).catch((r) => {
                    this.$data.isLoading = false;
                   this.$store.commit('LOAD_MORE_BAR_VISIBLE', { isVisible: false,});
                })
            }
        }

       
        download_callreport(){
           this.dateError = false;
            if (!this.startDate || !this.endDate) {
                this.dateError = true;
            }
            if (!this.loading && !this.dateError) {
                 this.repsummary=true;
                this.summary_loading = true;
                this.$store.dispatch('Summary_getCallReports', {para:{ shouldContinue: false }})
                .then((r) => {
                   
                    this.downloadXCL();
                }).catch((r) => {
                   //this.$store.commit('LOAD_MORE_BAR_VISIBLE', { isVisible: false,});
                })
            }
        }
        async downloadXCL() {
            this.$data.isLoading=true;
           await this.$store.dispatch('Summary_getCallReports', {para:{ shouldContinue: false , Page:-1}}).then((r) => {
                    this.TextExcelDoc_download(r.cdrs);
                    this.summary_loading = false;
                }).catch((r) => {
                    this.summary_loading = false;
                })
        }
         TextExcelDoc_download(list) {
			var wb = XLSX.utils.book_new();
				var data = [
                    ['Call Direction','Dialed Number','Duration','From Name'
                    ,'From Number',"ID", 'Timestamp','To Name','To Number'],
                ];
                
                var rec= list;//  this.cdrs;
           for(var i=0; i< rec.length; i++)  
			  {
                var durationf = function (value){
                    const duration = momentTZ.duration(+value, 'seconds');
                           return momentTZ.utc(duration.asMilliseconds()).format("mm:ss ")
                };

                var timestampf =function (value,tz){
                    return momentTZ(momentTZ(value, 'x').format()).tz(tz).format('Y-MM-DD h:mm a')
        
                }
                 var duration= durationf(rec[i].duration);
                  var timestamp= timestampf(rec[i].timestamp,this.timezone.tz);


                 

                data.push([rec[i].call_direction,rec[i].dialed_number,duration,rec[i].from_name
                ,rec[i].from_number,rec[i].id,timestamp,rec[i].to_name,rec[i].to_number]);
               
				
				}
			var wb = XLSX.utils.book_new();
			var ws = XLSX.utils.json_to_sheet(data, {skipHeader: true,cellDates:true});
			var range = XLSX.utils.decode_range(ws["!ref"]);
			   if(!ws['!cols']) ws['!cols'] = [];
			   if(!ws.A1.c) ws.A1.c = [];
			   var n0=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[0]? o[0].length: 5; 
                  }));
            var n1=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[1]? o[1].length: 5; 
                  }));
            var n2=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[2]? o[2].length: 5; 
                  }));
            var n3=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[3]? o[3].length: 5; 
                  }));
            var n4=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[4]? o[4].length: 5; 
                  }));
            var n5=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[5]? o[5].length: 5; 
                  }));
            var n6=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[6]? o[6].length: 5; 
                  }));
            var n7=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[7]? o[7].length: 5; 
                  }));
            var n8=  Math.max.apply(Math, data.map(function(o) { 
                 
                  return o[8]? o[8].length: 5; 
                  }));
              var wscols = [{wch:n0},{wch:n1},{wch:n2},{wch:n3},{wch:n4},{wch:n5+10},{wch:n6},{wch:n7},{wch:n8}];
               ws['!cols'] = wscols;
               ws["!margins"]={left:6.0, right:8.0, top:9.0, bottom:1.0, header:0.5,footer:0.5};
		       XLSX.utils.book_append_sheet(wb, ws, "No Header");
				
			var wbout = XLSX.write(wb, {bookType:'xlsx', type:'array'});
		 	saveAs(new Blob([wbout],{type:"application/octet-stream"}), "Call_Records.xlsx");

		}

    }
